'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCHEDULED = exports.SCHEDULED = 'SCHEDULED';
var SIMULATED = exports.SIMULATED = 'SIMULATED';
var UNPUBLISHED = exports.UNPUBLISHED = 'UNPUBLISHED';
var PUBLISHED = exports.PUBLISHED = 'PUBLISHED';
var PUBLISH_FAILED = exports.PUBLISH_FAILED = 'PUBLISH_FAILED';